module.exports = __webpack_public_path__ + "static/testingtime-9470e869d0fe5958a0f549ce463b1023.png";